import AuthorizationHelper from '@auth/services/authorization.helper';
import ModulesHelper from '@core/services/modules.helper';

export const mainAccountingRoutes = [
  {
    path: 'orders',
    name: 'admin-orders',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.orders],
      module: ModulesHelper.ACCOUNTING_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-orders" */ '@accounting/pages/orders/orders.vue'),
  },
  {
    path: 'orders/items',
    name: 'admin-order-items',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.orders],
      module: ModulesHelper.ACCOUNTING_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-order-items" */ '@accounting/pages/order-items/order-items.vue'
      ),
  },
  {
    path: 'invoices',
    exact: false,
    name: 'admin-invoices',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
      module: ModulesHelper.ACCOUNTING_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-invoices" */ '@accounting/pages/invoices/invoices.vue'),

    children: [
      {
        name: 'admin-orders-to-invoice',
        path: 'orders/waiting',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
          module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        },
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "admin-payments" */ '@accounting/components/containers/invoice/invoice-container.vue'
          ),
      },
      {
        name: 'admin-invoices-in-draft',
        path: 'draft',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
          module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        },
        component: () =>
          import(
            /* webpackChunkName: "admin-payments" */ '@accounting/components/containers/invoice/invoice-container.vue'
          ),
      },
      {
        name: 'admin-invoices-paid-and-to-pay',
        path: 'paid-and-to-pay',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
          module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        },
        component: () =>
          import(
            /* webpackChunkName: "admin-payments" */ '@accounting/components/containers/invoice/invoice-container.vue'
          ),
      },
      {
        name: 'admin-invoices-to-pay',
        path: 'to-pay',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
          module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        },
        component: () =>
          import(
            /* webpackChunkName: "admin-payments" */ '@accounting/components/containers/invoice/invoice-container.vue'
          ),
      },
      {
        name: 'admin-invoices-paid',
        path: 'paid',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
          module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        },
        component: () =>
          import(
            /* webpackChunkName: "admin-payments" */ '@accounting/components/containers/invoice/invoice-container.vue'
          ),
      },
      {
        name: 'admin-invoices-to-sync',
        path: 'to-sync',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
          module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        },
        component: () =>
          import(
            /* webpackChunkName: "admin-payments" */ '@accounting/components/containers/invoice/invoice-container.vue'
          ),
      },
      {
        name: 'admin-invoices-synchronized',
        path: 'synchronized',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
          module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        },
        component: () =>
          import(
            /* webpackChunkName: "admin-payments" */ '@accounting/components/containers/invoice/invoice-container.vue'
          ),
      },
      {
        name: 'admin-invoices-trashed',
        path: 'trashed',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
          module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        },
        component: () =>
          import(
            /* webpackChunkName: "admin-payments" */ '@accounting/components/containers/invoice/invoice-container.vue'
          ),
      },
    ],
  },
  {
    path: 'credit-notes',
    exact: false,
    name: 'admin-credit-notes',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
      module: ModulesHelper.ACCOUNTING_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-invoices" */ '@accounting/pages/credit-notes/credit-notes.vue'
      ),

    children: [
      {
        name: 'admin-orders-to-credit',
        path: 'orders/waiting',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
          module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        },
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "admin-payments" */ '@accounting/components/containers/credit-note/credit-note-container.vue'
          ),
      },
      {
        name: 'admin-credit-notes-in-draft',
        path: 'draft',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
          module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        },
        component: () =>
          import(
            /* webpackChunkName: "admin-payments" */ '@accounting/components/containers/credit-note/credit-note-container.vue'
          ),
      },
      {
        name: 'admin-credit-notes-paid-and-to-pay',
        path: 'paid-and-to-pay',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
          module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        },
        component: () =>
          import(
            /* webpackChunkName: "admin-payments" */ '@accounting/components/containers/credit-note/credit-note-container.vue'
          ),
      },
      {
        name: 'admin-credit-notes-to-pay',
        path: 'to-pay',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
          module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        },
        component: () =>
          import(
            /* webpackChunkName: "admin-payments" */ '@accounting/components/containers/credit-note/credit-note-container.vue'
          ),
      },
      {
        name: 'admin-credit-notes-paid',
        path: 'paid',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
          module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        },
        component: () =>
          import(
            /* webpackChunkName: "admin-payments" */ '@accounting/components/containers/credit-note/credit-note-container.vue'
          ),
      },
      {
        name: 'admin-credit-notes-to-sync',
        path: 'to-sync',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
          module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        },
        component: () =>
          import(
            /* webpackChunkName: "admin-payments" */ '@accounting/components/containers/credit-note/credit-note-container.vue'
          ),
      },
      {
        name: 'admin-credit-notes-synchronized',
        path: 'synchronized',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
          module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        },
        component: () =>
          import(
            /* webpackChunkName: "admin-payments" */ '@accounting/components/containers/credit-note/credit-note-container.vue'
          ),
      },
      {
        name: 'admin-credit-notes-trashed',
        path: 'trashed',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
          module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        },
        component: () =>
          import(
            /* webpackChunkName: "admin-payments" */ '@accounting/components/containers/credit-note/credit-note-container.vue'
          ),
      },
    ],
  },
  {
    path: 'tickets',
    exact: false,
    name: 'admin-tickets',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
      module: ModulesHelper.ACCOUNTING_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-invoices" */ '@accounting/pages/tickets/tickets.vue'),
  },
  {
    path: 'credit-notes',
    name: 'admin-credit-notes',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
      module: ModulesHelper.ACCOUNTING_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-credit-notes" */ '@accounting/pages/credit-notes/credit-notes.vue'
      ),
  },
  {
    path: 'tickets',
    name: 'admin-tickets',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
      module: ModulesHelper.ACCOUNTING_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-tickets" */ '@accounting/pages/tickets/tickets.vue'),
  },
  {
    path: 'payments',
    name: 'admin-payments',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.payments],
      module: ModulesHelper.ACCOUNTING_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-payments" */ '@accounting/pages/payments/payments.vue'),
  },
  {
    path: 'club-payments',
    name: 'admin-club-payments',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.payments],
      module: ModulesHelper.ACCOUNTING_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-club-payments" */ '@accounting/pages/club-payments.vue'),
  },
  {
    path: 'coupons',
    name: 'admin-coupons',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.coupons],
      module: ModulesHelper.ACCOUNTING_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-coupons" */ '@accounting/pages/coupons/coupons.vue'),
  },
  {
    path: 'mandates',
    name: 'admin-mandates',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.mandates],
      module: ModulesHelper.ACCOUNTING_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-mandates" */ '@accounting/pages/mandates/mandates.vue'),
  },
  {
    path: 'direct-debit-files',
    exact: false,
    name: 'admin-direct-debit-files',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.direct_debit_files],
      module: ModulesHelper.ACCOUNTING_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-direct-debit-files" */ '@accounting/pages/direct-debit-files/direct-debit-files.vue'
      ),
    children: [
      {
        name: 'direct-debit-files',
        path: 'files',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.direct_debit_files],
          module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        },
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "admin-direct-debit-files" */ '@accounting/components/containers/direct-debit-file/direct-debit-file-container.vue'
          ),
      },
      {
        name: 'tickets-for-direct-debit-file',
        path: 'tickets-for-direct-debit-file',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.direct_debit_files],
          module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        },
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "admin-direct-debit-files" */ '@accounting/components/containers/direct-debit-file/direct-debit-file-container.vue'
          ),
      },
      {
        name: 'tickets-refused',
        path: 'tickets-refused',
        meta: {
          layout: 'bpc-admin',
          withSidebar: false,
          permissions: [AuthorizationHelper.fixedPermissions.sidebar.direct_debit_files],
          module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        },
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "admin-direct-debit-files" */ '@accounting/components/containers/direct-debit-file/direct-debit-file-container.vue'
          ),
      },
    ],
  },
  {
    path: 'codas',
    name: 'admin-codas',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.codas],
      module: ModulesHelper.CODA_MANAGEMENT_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-codas" */ '@accounting/pages/codas/codas.vue'),
  },
  {
    path: 'coda-transactions',
    name: 'admin-coda-transactions',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.codas],
      module: ModulesHelper.CODA_MANAGEMENT_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-codas" */ '@accounting/pages/coda-lines/coda-lines.vue'),
  },
  {
    path: 'accounting-reports',
    name: 'admin-accounting-reports',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.accounting_reports],
      module: ModulesHelper.ACCOUNTING_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-accounting-reports" */ '@accounting/pages/accounting-reports-page.vue'
      ),
  },
  {
    path: 'sales-report',
    name: 'admin-sales-report',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.sales_report],
      module: ModulesHelper.ACCOUNTING_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-sales-report" */ '@accounting/pages/sales-report-page.vue'
      ),
  },
];

export const configurationAccountingRoutes = [
  {
    path: 'taxes',
    name: 'admin-taxes',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.taxes],
    },
    component: () =>
      import(/* webpackChunkName: "admin-taxes" */ '@accounting/pages/taxes/taxes.vue'),
  },
  {
    path: 'accounting-journals',
    name: 'admin-accounting-journals',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.accounting_journals],
      module: ModulesHelper.ACCOUNTING_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-accounting-journals" */ '@accounting/pages/accounting-journals/accounting-journals.vue'
      ),
  },
  {
    path: 'accounts',
    name: 'admin-accounts',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.accounts],
      module: ModulesHelper.ACCOUNTING_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-accounts" */ '@accounting/pages/accounts/accounts.vue'),
  },
  {
    path: 'analytic-accounts',
    name: 'admin-analytic-accounts',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.analytic_accounts],
      module: ModulesHelper.ACCOUNTING_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-analytic-accounts" */ '@accounting/pages/analytic-accounts/analytic-accounts.vue'
      ),
  },
  {
    path: 'article-tags',
    name: 'admin-article-tags',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.article_tags],
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-article-tags" */ '@accounting/pages/article-tags/article-tags.vue'
      ),
  },
  {
    path: 'articles',
    name: 'admin-articles',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.articles],
    },
    component: () =>
      import(/* webpackChunkName: "admin-articles" */ '@accounting/pages/articles/articles.vue'),
  },
  {
    path: 'article-prices',
    name: 'admin-article-prices',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.articles],
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-articles" */ '@accounting/pages/article-prices/article-prices.vue'
      ),
  },
  {
    path: 'discount-categories',
    name: 'admin-discount-categories',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.discount_categories],
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-discounts" */ '@accounting/pages/discount-categories/discount-categories.vue'
      ),
  },
];

export const publicAccountingRoutes = [];
